import React, { useContext, useState } from "react";
import { SafeAreaView, Text } from "react-native";
import _ from "lodash";

import { BasicText, Button } from "./Styles";
import { Bound, useMagic } from "opidcore";
import { InputText } from "./core";

import styled from "styled-components/native";
import { COLORS } from "../WasteTheme";
import { useOpidNavigator } from "./core/OpidNavigator";
import Util from "./core/Util";

const AppLogin = ({ portalData }) => {
  const bound = useMagic({});
  const [loginError, setLoginError] = useState("");
  const navigation = useOpidNavigator();

  /** useEffect(()=>{
        if(portalDataContext.authToken != undefined ){
            fetch(getHost() + "/api/v1/portal/fetchSupportTickets?authToken=" + portalDataContext.authToken.code).then( (r)=>r.json() ).then( (result)=>{
                setSupportData(result);
            });
        }
    }, [portalData]); **/

  const LoginButton = styled.TouchableOpacity`
    margin: 15px;
    background-color: ${COLORS.wsc_blue};
    width: 200px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const LoginText = styled(BasicText)`
    color: white;
    font-weight: bold;
    font-size: 12px;
  `;

  const doLogin = () => {
    const loginUrl = Util.getHost() + "/portal/login";
    const args = {
      app: "true",
      email: bound.magicalGet("email"),
      password: bound.magicalGet("password"),
    };

    fetch(loginUrl, {
      body: JSON.stringify(args),
      mode: "cors",
      method: "POST",
      headers: { "Content-Type": "application/json", portalUI: "yes" }, //portalUI header used in backend api authentication
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.token != null) {
          setLoginError("");
          navigation.goto("/auth/" + r.token);
        } else {
          setLoginError("Login Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <SafeAreaView>
      <BasicText>Login</BasicText>
      {loginError > "" ? <BasicText>{loginError}</BasicText> : null}
      <Bound to={bound}>
        <InputText field="email" style={{ width: "90%" }} />
        <InputText field="password" password={true} style={{ width: "90%" }} />
      </Bound>
      <LoginButton onPress={doLogin}>
        <LoginText>Login</LoginText>
      </LoginButton>
    </SafeAreaView>
  );
};

export default AppLogin;
